import React from 'react';
import ReportDetails from '../ReportDetails';

import {
  EMPLOYEES_USERS_DESCRIPTION,
  EMPLOYEES_USERS_DESCRIPTION_FOR_MIXED_PLAN
} from '../../utils/resources/reports';

const ReportDetailsEmployeeUsers = props => <ReportDetails {...props} />;

ReportDetailsEmployeeUsers.defaultProps = {
  title: 'Employees',
  subtitle: 'last month',
  description: EMPLOYEES_USERS_DESCRIPTION,
  descriptionForMixedPlan: EMPLOYEES_USERS_DESCRIPTION_FOR_MIXED_PLAN,
  tabs: [
    {
      title: 'Employees',
      selector: 'employeeUserByMonth',
      csvFilename: 'employeeUsersByMonth',
      csvDescription:
        'This table shows monthly employee users for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        all_internal_users: 'Employee Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Employees'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'all_internal_users'
        }
      ]
    },
    {
      title: 'Employees by Tenant',
      selector: 'employeeUserByTenantMonth',
      csvFilename: 'employeeUsersByTenantMonth',
      csvDescription:
        'This table shows monthly employee users for each tenant for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        tenant: 'Tenant',
        all_internal_users: 'Employee Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Tenant',
          keyName: 'tenant',
          isFilter: true
        },
        {
          title: 'Employees'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'tenant',
          isTooltip: true
        },
        {
          keyName: 'all_internal_users'
        }
      ]
    }
  ],
  applianceTabs: [
    {
      title: 'Employees',
      selector: 'employeeUserByMonth',
      csvFilename: 'employeeActiveUsersByMonth',
      csvDescription:
        'This table shows monthly employee users for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        all_internal_users: 'Employee Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Employees'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'all_internal_users'
        }
      ]
    },
    {
      title: 'Employees by Private Instance',
      selector: 'employeeUserByApplianceMonth',
      csvFilename: 'employeeActiveApplianceUsersByAppliance',
      csvDescription:
        'This table shows monthly employee users for each tenant for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        environment: 'Environment',
        root_domain_auth: 'Private Instance',
        all_internal_users: 'Employee Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Environment',
          keyName: 'environment',
          isFilter: true
        },
        {
          title: 'Private Instance',
          keyName: 'root_domain_auth',
          isFilter: true
        },
        {
          title: 'Employees'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'environment',
          isTooltip: true
        },
        {
          keyName: 'root_domain_auth',
          isTooltip: true
        },
        {
          keyName: 'all_internal_users'
        }
      ]
    },
    {
      title: 'Employees by Tenant',
      selector: 'employeeUserByAppplianceByTenantMonth',
      csvFilename: 'employeeActiveApplianceUsersByTenant',
      csvDescription:
        'This table shows monthly employee users for each tenant for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        environment: 'Environment',
        root_domain_auth: 'Private Instance',
        tenant: 'Tenant',
        all_internal_users: 'Employee Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Environment',
          keyName: 'environment',
          isFilter: true
        },
        {
          title: 'Private Instance',
          keyName: 'root_domain_auth',
          isFilter: true
        },
        {
          title: 'Tenant',
          keyName: 'tenant',
          isFilter: true
        },
        {
          title: 'Employees'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'environment',
          isTooltip: true
        },
        {
          keyName: 'root_domain_auth',
          isTooltip: true
        },
        {
          keyName: 'tenant',
          isTooltip: true
        },
        {
          keyName: 'all_internal_users'
        }
      ]
    }
  ]
};

export default ReportDetailsEmployeeUsers;
